import requestService from '~/services/requestsService';

const BASE_URL = '/followers';

const followUser = (userId: string) => {
  return requestService.post(`${BASE_URL}/${userId}`);
};

const unfollowUser = (userId: string) => {
  return requestService.delete(`${BASE_URL}/${userId}`);
};

const followersService = {
  followUser,
  unfollowUser,
};

export default followersService; 